import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, useNavigate } from 'react-router-dom';
import Layout from './layouts/Layout.jsx';
import Home from './pages/Home';
import './output.css';  // Important !
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MessagesList from './pages/MessagesList';
import MessagesHistory from './pages/MessagesHistory';

const router = createBrowserRouter([
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/register",
    element: <Register />
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />
  },
  {
    path: "/reset-password",
    element: <ResetPassword />
  },
  {
    path: "/",
    element: <ProtectedRoute><Layout><Home /></Layout></ProtectedRoute>
  },
  {
    path: "/messages/list",
    element: <ProtectedRoute><Layout><MessagesList /></Layout></ProtectedRoute>
  }
  ,
  {
    path: "/messages/history",
    element: <ProtectedRoute><Layout><MessagesHistory /></Layout></ProtectedRoute>
  }
]);

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

// Composant pour protéger les routes
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  if (loading) return null;
  return user ? children : null;
}

export default App;